var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.comments),function(comment,idx){return _c('div',[_c('Comment',{attrs:{"comment":comment}}),(idx < _vm.comments.length -1)?_c('hr',{staticClass:"has-background-grey"}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }